<template>
  <Loading v-if="isLoading" />
  <div v-else>
    <vs-row vs-justify="space-between">
      <vs-col vs-w="6">
        <h3 class="mr-4">General settings</h3>
        <p class="mt-5 mb-6">
          These settings are global and applied across all countries, regions
          and venues.
        </p>
      </vs-col>
    </vs-row>

    <vx-card no-shadow>
        <h5>Stocktake</h5>
      <div class="vx-row mb-6 mt-3">
        <div class="vx-col sm:w-1/5 mt-2 w-full">
          <span>Allowed stocktake deviation</span>
        </div>
        <div class="vx-col">
          <vs-input-number
            label="%"
            v-model="
              settings.pimSettings.stocktakeDefaultAllowedDeviationPercentage
            "
            :min="0"
            :max="100"
            step="1"
            class="justify-start bg-transparent"
          ></vs-input-number>
        </div>
      </div>

      <!-- Save & Remove Button -->
      <vs-row
        vs-justify="space-between"
        class="flex flex-wrap items-center"
        style="margin-top: 32px"
      >
        <vs-button id="save-button" @click="update" class="mt-2"
          >Save Changes</vs-button
        >
      </vs-row>
    </vx-card>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  components: {},
  data() {
    return {
      isLoading: true,
    };
  },
  methods: {
    async update() {
      this.$vs.loading();
      try {
        console.log("Updating", this.settings);
        await this.$store.dispatch("pimSettings/updateSettings", this.settings);
        this.$vs.notify({
          color: "green",
          title: "Updated",
          text: "Settings updated",
        });
      } catch (err) {
        console.error(err);
        this.$vs.notify({
          color: "danger",
          title: "Error saving",
          text: "Error saving",
        });
      } finally {
        this.$vs.loading.close();
      }
    },
  },
  computed: {
    ...mapGetters({
      //   emailSignature: "email/emailSignature",
      settings: "pimSettings/settings",
    }),
  },

  async mounted() {
    this.isLoading = true;
    await this.$store.dispatch("pimSettings/getSettings");
    this.isLoading = false;
  },
};
</script>

